module.exports = __webpack_public_path__ + "static/media/phone3.b642b4a9.svg";